module.exports = __webpack_public_path__ + "static/media/Galdisa_Ficha_MaizChileLimon.f1be682c.pdf";